import { useState } from 'react';
import Button from 'react-bootstrap/Button';
import DropdownItem from 'react-bootstrap/DropdownItem';
import ConfirmationModal from '@enerex/unified-ui-react/ConfirmationModal';

import { useToggle } from 'hooks';
import InfoIcon from '@enerex/unified-ui-react/icons/InfoIcon';
import DeleteIcon from '@enerex/unified-ui-react/icons/DeleteIcon';

type ConfirmButtonProps = {
    children?: React.ReactNode;
    title?: string;
    message?: React.ReactNode;
    onConfirm: () => Promise<void>;
    variant?: 'button' | 'icon' | 'iconComponent' | 'dropdownItem';
    disabled?: boolean;
    label?: React.ReactNode;
    confirmLabel?: string;
    cancelLabel?:string;
    showCancelButton?: boolean;
    confirmVariant?: 'primary' | 'danger' | 'success' | 'warning' | 'secondary';
    buttonVariant?: 'primary' | 'danger' | 'success' | 'warning' | 'secondary' | 'outline-danger' | 'outline-primary';
};

const ConfirmButton = ({
    title,
    message,
    onConfirm,
    variant = 'button',
    disabled,
    label: text = 'Process',
    confirmLabel = 'Ok',
    confirmVariant = 'primary',
    buttonVariant = 'primary'
}: ConfirmButtonProps) => {
    const { isOpen, show, hide } = useToggle();
    const [isLoading, setIsLoading] = useState<boolean>(false);

    const handleConfirm = async () => {
        try {
            setIsLoading(true);
            await onConfirm();
            hide();
        } finally {
            setIsLoading(false);
        }
    };
    return (
        <>
            {variant === 'iconComponent' ? (
                <InfoIcon
                    role="button"
                    style={{ fontSize: 18, marginLeft: 6 }}
                    onClick={show}
                />
            ) : variant === 'icon' ? (
                <DeleteIcon
                    role="button"
                    style={{ fontSize: 18 }}
                    onClick={show}
                />
            ) : variant === 'dropdownItem' ? (
                <DropdownItem onClick={show} disabled={disabled}>
                    {text}
                </DropdownItem>
            ) : (
                <Button variant={buttonVariant} onClick={show} disabled={disabled}>
                    {text}
                </Button>
            )}
            <ConfirmationModal
                dialogClassName="modal-md"
                show={isOpen}
                onHide={hide}
                size={'lg'}
                scrollable={true}
                title={title || 'Are you sure?'}
                confirmButtonLabel={confirmLabel}
                confirmButtonVariant={confirmVariant}
                isLoading={isLoading}
                onConfirm={handleConfirm}
            >
                {message || 'Are you sure you want to continue?'}
            </ConfirmationModal>
        </>
    );
};

export default ConfirmButton;
